import { Animated, Platform, Pressable } from "react-native"
import { Text, View } from "react-native"
import WebView from "react-native-webview"
import { store } from "@reduxLocal/persistState"
import { CLEAR_SELECTED_MAIL, SHOW_CALENDAR_ENTRY_MODAL } from "@reduxLocal/actions/types"
import { navigationRef } from "@navigation/rootNavigation"
import styles from "@stylesheet"
import { Ionicons, FontAwesome5, FontAwesome, MaterialCommunityIcons } from '@expo/vector-icons';
import React, { useCallback, useEffect, useState } from "react"
import { Easing, useAnimatedStyle, useSharedValue, withSpring } from 'react-native-reanimated';
import * as Animatable from 'react-native-animatable';
import apis from "@api/api";
import { Buffer } from 'buffer';


const IndividualMailComponent = ({ handleMarked, mailSelected, tokenAccess, ...props }) => {
  const [plusRotated, setPlusRotated] = useState(false);
  const rotation = new Animated.Value(0);

  // Early return if no mail is selected
  if (!mailSelected) {
    return (
      <View style={{ alignSelf: 'stretch', borderRadius: 20, backgroundColor: 'white', shadowRadius: 20, shadowOpacity: .2, padding: 20, flex: 1, justifyContent: 'center', alignItems: 'center', ...props }}>
        <Text style={{ fontSize: 16, color: '#666' }}>Select an email to view its contents</Text>
      </View>
    );
  }

  console.log('IndividualMailComponent rendering with mail:', mailSelected ? 'has mail' : 'no mail');

  const _handleMarkMail = useCallback((mail) => {
    console.log(mail);
    handleMarked(mail)
  }, [mailSelected])

  useEffect(() => {
    handleMarkMail()
  }, [])

  const handleMarkMail = async () => {
    await apis.markRead(mailSelected?.id, tokenAccess)
      .then(res => _handleMarkMail(res.data.messages[0]))
  }

  const spinLeft = () => {
    Animated.timing(rotation,
      {
        toValue: 1,
        duration: 100,
        easing: Easing.linear,
        useNativeDriver: false
      }).start((complete => {
        setPlusRotated(true)
      }))
  }

  const spinRight = () => {
    Animated.timing(rotation,
      {
        toValue: 0,
        duration: 5000,
        easing: Easing.linear,
        useNativeDriver: true
      }).start((complete => {
        setPlusRotated(false)
      }))
  }

  const spin = rotation.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '45deg']
  })

  const from = () => {
    if (mailSelected && mailSelected.payload && mailSelected.payload.headers) {
      let fromHeader = mailSelected.payload.headers.find(from => from.name === 'From');
      return fromHeader ? fromHeader.value : 'Unknown sender';
    }
    return 'Unknown sender';
  }

  const to = () => {
    if (mailSelected && mailSelected.payload && mailSelected.payload.headers) {
      let toHeader = mailSelected.payload.headers.find(to => to.name === 'To');
      return toHeader ? toHeader.value : 'Unknown recipient';
    }
    return 'Unknown recipient';
  }

  const subject = () => {
    if (mailSelected && mailSelected.payload && mailSelected.payload.headers) {
      let subjectHeader = mailSelected.payload.headers.find(subject => subject.name === 'Subject');
      return subjectHeader ? subjectHeader.value : 'No subject';
    }
    return 'No subject';
  }

  const body = () => {
    if (!mailSelected || !mailSelected.payload) {
      return '<div>No content available</div>';
    }

    try {
      if (mailSelected.payload.parts) {
        const partMail = mailSelected.payload.parts.find(parts => parts.mimeType === 'text/html');
        if (partMail && partMail.body && partMail.body.data) {
          let html = Buffer.from(partMail.body.data, 'base64').toString();
          return html;
        }
      } else if (mailSelected.payload.body && mailSelected.payload.body.data) {
        let html = Buffer.from(mailSelected.payload.body.data, 'base64').toString();
        return html;
      }
    } catch (error) {
      console.error('Error parsing email body:', error);
      return '<div>Error loading email content</div>';
    }
    
    return '<div>No content available</div>';
  }

  const customHtml = body();

  return (
    <View style={{ alignSelf: 'stretch', borderRadius: 20, backgroundColor: 'white', shadowRadius: 20, shadowOpacity: .2, padding: 20, flex: 1, ...props }}>
      <View style={{ backgroundColor: 'white', flexDirection: 'row', borderRadius: 20, borderBottomStartRadius: 0, borderBottomEndRadius: 0, padding: 5, flex: 1, elevation: 1, shadowRadius: 5, shadowOpacity: 0.4, zIndex: 2, alignSelf: 'stretch', minHeight: 100 }}>
        {/* <Pressable
          onPress={() => {
            navigationRef.goBack()
          }}
          style={[styles.BackToLogin, { minWidth: 10, flexDirection: 'row', flex: 1, justifyContent: 'space-evenly', borderRadius: 40 }]}
        >
          <View />
          <Ionicons name={"arrow-back-outline"} size={20} color={'white'} ></Ionicons>
          <View />
        </Pressable> */}
        <View style={{ flexDirection: 'column', flex: 10, padding: 20, gap: 10 }}>
          <View style={{ flex: 1, flexDirection: 'row' }}>
            <Text adjustsFontSizeToFit style={{ marginHorizontal: 5, fontWeight: '600' }}>From</Text>
            <Text adjustsFontSizeToFit >{from()}</Text>
          </View>
          <View style={{ flex: 2, flexDirection: 'row' }}>
            <Text adjustsFontSizeToFit style={{ marginHorizontal: 5, fontWeight: '600' }}>Subject</Text>
            <Text adjustsFontSizeToFit >{subject()}</Text>
          </View>
        </View>
      </View>
      <View style={{ flex: 30, borderRadius: 20, minHeight: '100%' }}>
        <WebView originWhitelist={['*']} source={{ html: customHtml }} style={{ alignSelf: 'stretch', height: 800, marginBottom: 30, paddingBottom: 50 }} ></WebView>
      </View>
    </View>
  )
}
export default IndividualMailComponent